import { useContext } from 'react'
import { useNavigate } from 'react-router'
import { DeleteOutlined } from '@mui/icons-material'
import { Button, DialogContent, DialogContentText, Grid } from '@mui/material'
import { useSnackbar } from 'notistack'

import DialogWithTitle from '../../../../../components/dialog-with-title'
import { useHost } from '../../../../../providers/app-provider'
import Api from '../../../../../utils/api'
import PeopleContext from '../../../context'
import useStyles from '../../../index.styles'

const DeleteModal = ({ open, setOpen }: { open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const classes = useStyles

  const { enqueueSnackbar } = useSnackbar()
  const { user } = useContext(PeopleContext)
  const host = useHost()
  const navigate = useNavigate()

  const handleDelete = async () => {
    setOpen(false)

    if (user) {
      const res = await Api.del(`${host}/api/users/${user.id}`)
      if (res.ok) {
        enqueueSnackbar('User deleted successfully')
        navigate('/dashboard')
      } else {
        enqueueSnackbar('Could not delete user')
      }
    }
  }

  return (
    <DialogWithTitle title="Delete" open={open} setOpen={setOpen} data-cy="deleteUserModal">
      <DialogContent>
        <DialogContentText sx={classes.dialogText}>You are about to delete this user and all associated data.</DialogContentText>

        <DialogContentText sx={classes.dialogText}>Cannot undo this action.</DialogContentText>

        <Grid
          container={true}
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <Button variant="outlined" sx={classes.dialogButtons} onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <Button variant="contained" sx={classes.dialogButtons} onClick={handleDelete} startIcon={<DeleteOutlined />} color="error">
            Delete
          </Button>
        </Grid>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default DeleteModal
